import React from 'react';

function Bio() {
  return (
    <section id="bio">
      <h2>Bio</h2>
      <p>"TimeWaster, a dynamic force in the Hard Dance scene, hails from the Netherlands. Renowned for his pulsating beats and electrifying performances, TimeWaster has carved a niche for himself in the realm of Hard Dance.</p>
      <p>Collaborating with industry titans such as DJ THT, Bonkerz, and Withard, TimeWaster's influence spans far and wide. His remixes for esteemed artists including Gregory Morrison, NENO, Basslouder & Tronix DJ, DJ R.Gee & DJ Toxic, Withard & TrebleDance, and Bonkerz have garnered widespread acclaim and cemented his status as a formidable producer.</p>
      <p>A beacon of the Hard Dance community, TimeWaster hosts the weekly livestream '<a href="https://www.youtube.com/playlist?list=PL8NAQLKfkt3qwhB1TA4Orw6yyNlDceWW1" rel="noopener">Rave Cave</a>,' showcasing the latest and greatest in the genre. With his unwavering dedication to pushing boundaries and crafting infectious beats, TimeWaster continues to captivate audiences worldwide."</p>
    </section>
  );
}

export default Bio;
